import { produce } from 'immer';

import { COMPANY_ROLE_RESTRICTIONS_ACTION_TYPE } from '../actions/companyRoleRestrictions.actions';

const initialState = {
  data: [],
};

const companyRoleRestrictionsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMPANY_ROLE_RESTRICTIONS_ACTION_TYPE.GET_RESTRICTIONS:
      case COMPANY_ROLE_RESTRICTIONS_ACTION_TYPE.UPDATE_RESTRICTIONS:
        draft.data = payload || [];
        break;

      case COMPANY_ROLE_RESTRICTIONS_ACTION_TYPE.RESET_RESTRICTIONS:
        draft.data = [];
        break;

      default:
        return state;
    }
  });

export default companyRoleRestrictionsReducer;
